import { useState, useEffect } from "react"
import logo from "../images/brand/logo.png";
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import { useUser } from "../utils/UserContext";
import { Toaster, toast } from 'react-hot-toast';
import { useLocation } from "react-router-dom";

function Forget() {
    const { user } = useUser();
    useEffect(() => {
      if (user) {
        navigate("/dashboard");
      }
    }, [user]);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get("emailid");
    const key = queryParams.get("wankandakey");
    if (!email || !key) {
        navigate("/forgot-password");
    }
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [valid, setValid] = useState(true);
  const [pass1, setPass1] = useState();
  const [pass2, setPass2] = useState();
  const [error, setError] = useState(false);
  const [error1, setError1] = useState(false);
  const [errorValue, setErrorValue] = useState();
  const [errorValue1, setErrorValue1] = useState();
  const navigate = useNavigate();
    function validatePassword (value){
        setPass1(value);
        if (value.length < 8) {
            setError(true);
            setErrorValue("Password must be at least 8 characters long.");
        } else if (!/[A-Z]/.test(value)) {
            setError(true);
            setErrorValue("Password must contain at least one uppercase letter.");
        } else if (!/[a-z]/.test(value)) {
            setError(true);
            setErrorValue("Password must contain at least one lowercase letter.");
        } else if (!/[0-9]/.test(value)) {
            setError(true);
            setErrorValue("Password must contain at least one number.");
        } else {
            setError(false);
            setErrorValue("");
        }
    }
    function validateConfirm (value){
        setPass2(value);
        if (value !== pass1) {
            setError1(true);
            setErrorValue1("Passwords do not match.");
        } else {
            setError1(false);
            setErrorValue1("");
        }
    }
    const [see, setSee] = useState(false);
    const [see1, setSee1] = useState(false);
    useEffect(() => {
        if(pass1 && pass2){
          setDisable(false);
        }else{
          setDisable(true);
        }
      }, [pass1, pass2]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchReset : true, email : email, key : key })
    })
    .then(response =>  response.json())
    .then(data => {
      if (data.status === "success") {
        if(data.resetdetails === false){
            window.location.href = "login";
        }else{
            var resetdetails = data.resetdetails;
            const expireDate = new Date(resetdetails.expDate);
            const currentDate = new Date();
            if (expireDate < currentDate) {
                setValid(false);
            } else {
                setValid(true);
            }
        }
      }else{
        window.location.href = "login";
      }
    })
    .catch(err => {
      console.error(err);
      window.location.href = "login";
    })
  }, [email, key, valid]);

  const handleReset = () => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/reset.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_reset: true, email: email, pass1: pass1, pass2: pass2})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
            window.location.href = "dashboard";
        }, 2000);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  } 

  return (
    <div className="min-vh-100 d-flex flex-column text-white" style={{backgroundColor: 'rgb(5, 8, 11)', padding: '0px 32px 144px'}}>
      <div><Toaster/></div>
      <header className="d-flex align-items-center justify-content-between" style={{padding: '32px 0px'}}>
        <img src={logo} alt="logo" className="app-logo"/>
        <Link to="/" className="text-light text-decoration-none" style={{fontSize: '14px'}}>
          Back to homepage
        </Link>
      </header>
      <main className="flex-grow-1 d-flex justify-content-center p-3 mt-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-5 col-xl-4">
              <div className="mb-4">
                <h1 className="fs-4 fw-semibold">Reset your password</h1>
              </div>
              {!valid ? (
                <>
                    <h6 className="text-white fw-bold">Try resetting your password again</h6>
                    <p className="text-secondary fw-semibold">Your request to reset your password has expired or the link has already been used</p>
                    <Link to="/forget-password" className={`btn btn-secondary w-100 py-2 fw-bold`}>Return Back</Link>
                </>
              ) : (
                <>
            
                    <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>New password:</label>
                    <div className="d-flex align-items-center form-control justify-content-between py-2 pe-2">
                        <input 
                        type={see?"text":"password"}
                        placeholder="Your new password (min. of 8 characters)"
                        className="inputNone"
                        value={pass1}
                        onChange={(e) => validatePassword(e.target.value)}
                        />
                        <FontAwesomeIcon icon={(see === false)?faEye:faEyeSlash} className="ms-2" style={{fontSize: '12px'}} onClick={() => {
                            setSee(see === true ? false : true);
                            }}/>
                    </div>
                    {error && (
                        <p className="mb-0 text-danger fs-7 mt-1">{errorValue}</p>
                    )}
                    <label className="fw-semibold mt-3 mb-2" style={{fontSize: '14px'}}>Confirm new password:</label>
                    <div className="d-flex align-items-center form-control justify-content-between py-2 pe-2">
                        <input 
                        type={see1?"text":"password"}
                        placeholder="Retype your new password"
                        className="inputNone"
                        value={pass2}
                        onChange={(e) => validateConfirm(e.target.value)}
                        />
                        <FontAwesomeIcon icon={(see1 === false)?faEye:faEyeSlash} className="ms-2" style={{fontSize: '12px'}} onClick={() => {
                            setSee1(see1 === true ? false : true);
                        }}/>
                    </div>
                    {error1 && (
                        <p className="mb-0 text-danger fs-7 mt-1">{errorValue1}</p>
                    )}
                    <div className={`btn btn-secondary w-100 py-2 fw-bold mt-4 ${disable?'disabled':null}`} onClick={!disable ? handleReset : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Reset'}</div>
                </>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default Forget